import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getUtm() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  return utm;
}

export function hasAnalyticsConsent() {
  return localStorage.getItem("gpsl-consent") === "accepted";
}

export function trackEvent(type, meta = {}) {
  if (!hasAnalyticsConsent()) return;
  axios
    .post(`${API}/events`, { type, path: window.location.pathname, meta })
    .catch(() => {});
}

export function usePageView(pathname) {
  // called from a route-change effect
  trackEvent("page_view", { path: pathname });
}

export async function submitLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data.token;
}

export async function fetchLeads(token) {
  const { data } = await axios.get(`${API}/admin/leads`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export function exportLeadsUrl() {
  return `${API}/admin/leads/export`;
}
